"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var ConstraintSettingsConverter_1 = require("../../general-settings/conversions/constraint/ConstraintSettingsConverter");

var OptimizationGoalsSettingsConverter_1 = require("../../general-settings/conversions/optimalization-goal/OptimizationGoalsSettingsConverter");

var StrategySettingsConverter_1 = require("../../general-settings/conversions/strategy/StrategySettingsConverter");

var ReleasePriceCalculation_1 = require("../model/ReleasePriceCalculation");

var ReleasePriceCalculationOutput_1 = require("../model/ReleasePriceCalculationOutput");

var ReleasePriceCalculationRules_1 = require("../model/ReleasePriceCalculationRules");

var ReleasePriceCalculationState_1 = require("../model/ReleasePriceCalculationState");

var ReleasePriceCalculationConverter_1 = require("./ReleasePriceCalculationConverter");

var ReleasePriceCalculationConverterImpl =
/*#__PURE__*/
function (_ReleasePriceCalculat) {
  _inherits(ReleasePriceCalculationConverterImpl, _ReleasePriceCalculat);

  function ReleasePriceCalculationConverterImpl(constrainSettingsConverter, optimizationGoalsSettingsConverter, strategySettingsConverter) {
    var _this;

    _classCallCheck(this, ReleasePriceCalculationConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePriceCalculationConverterImpl).call(this));
    _this.constrainSettingsConverter = constrainSettingsConverter;
    _this.optimizationGoalsSettingsConverter = optimizationGoalsSettingsConverter;
    _this.strategySettingsConverter = strategySettingsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleasePriceCalculationConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ReleasePriceCalculation_1.ReleasePriceCalculation(conversions.documentToClassId(source), conversions.asObject(source, 'releaseId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'productCategoryId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'priceZoneId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectList(source, 'releaseItemIds', function (id) {
        return conversions.toClassReferenceId(id);
      }), conversions.asObjectList(source, 'settings', function (v) {
        return _this2.toCalcSettings(v, conversions);
      }), conversions.asObject(source, 'groupId', function (v) {
        return v;
      }), conversions.asObject(source, 'calculatorName', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'lastOutput', function (v) {
        return _this2.toCalcOutput(v, conversions);
      }), conversions.asObjectOpt(source, 'lastOutputTime', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'preserveManualPrices', function (v) {
        return utils_1.Utils.asBool(v);
      }));
    }
  }, {
    key: "toCalcSettings",
    value: function toCalcSettings(source, conversions) {
      var _this3 = this;

      return new ReleasePriceCalculationRules_1.ReleasePriceCalculationSettings(conversions.asObject(source, 'priceZoneId', function (value) {
        return conversions.toClassReferenceId(value);
      }), conversions.asObject(source, 'productCategoryId', function (value) {
        return conversions.toClassReferenceId(value);
      }), conversions.asObject(source, 'productSensitivityId', function (value) {
        return conversions.toClassReferenceId(value);
      }), conversions.asObject(source, 'rules', function (value) {
        return _this3.toCalcRules(value, conversions);
      }));
    }
  }, {
    key: "toCalcRules",
    value: function toCalcRules(source, conversions) {
      var _this4 = this;

      return new ReleasePriceCalculationRules_1.ReleasePriceCalculationRules(conversions.asObjectOpt(source, 'competitorHistoryLength', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'competitorsPriorityId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'constraintSettings', function (v) {
        return _this4.constrainSettingsConverter.toObject(v, conversions);
      }), conversions.asObjectOpt(source, 'optimizationGoalsSettings', function (v) {
        return _this4.optimizationGoalsSettingsConverter.toObject(v, conversions);
      }), conversions.asObjectOpt(source, 'strategySettings', function (v) {
        return _this4.strategySettingsConverter.toObject(v, conversions);
      }));
    }
  }, {
    key: "toCalcOutput",
    value: function toCalcOutput(source, conversions) {
      return new ReleasePriceCalculationOutput_1.ReleasePriceCalculationOutput(conversions.asObject(source, 'state', function (v) {
        return conversions.asEnum(v, ReleasePriceCalculationState_1.ReleasePriceCalculationState);
      }), conversions.asObject(source, 'stateDetail', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'data', function (v) {
        return v;
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this5 = this;

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        productCategoryId: conversions.toDocumentReferenceId(source.productCategoryId),
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        releaseItemIds: source.releaseItemIds.map(function (id) {
          return conversions.toDocumentReferenceId(id);
        }).toArray(),
        settings: source.settings.map(function (s) {
          return _this5.calcSettingsToDocument(s, conversions);
        }).toArray(),
        groupId: source.groupId,
        calculatorName: source.calculatorName,
        lastOutput: source.lastOutput != null ? this.calcOutputToDocument(source.lastOutput, conversions) : null,
        lastOutputTime: source.lastOutputTime != null ? conversions.fromDate(source.lastOutputTime) : null,
        preserveManualPrices: source.preserveManualPrices
      });
      return document;
    }
  }, {
    key: "calcSettingsToDocument",
    value: function calcSettingsToDocument(source, conversions) {
      return {
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        productCategoryId: conversions.toDocumentReferenceId(source.productCategoryId),
        productSensitivityId: conversions.toDocumentReferenceId(source.productSensitivityId),
        rules: this.calcRulesToDocument(source.rules, conversions)
      };
    }
  }, {
    key: "calcRulesToDocument",
    value: function calcRulesToDocument(source, conversions) {
      return {
        competitorHistoryLength: source.competitorHistoryLength,
        competitorsPriorityId: conversions.toDocumentReferenceId(source.competitorsPriorityId),
        constraintSettings: source.constraintSettings != null ? this.constrainSettingsConverter.toDocument(source.constraintSettings, conversions) : null,
        optimizationGoalsSettings: source.optimizationGoalsSettings != null ? this.optimizationGoalsSettingsConverter.toDocument(source.optimizationGoalsSettings, conversions) : null,
        strategySettings: source.strategySettings != null ? this.strategySettingsConverter.toDocument(source.strategySettings, conversions) : null
      };
    }
  }, {
    key: "calcOutputToDocument",
    value: function calcOutputToDocument(source, conversions) {
      return {
        state: ReleasePriceCalculationState_1.ReleasePriceCalculationState[source.state],
        stateDetail: source.stateDetail,
        data: source.data
      };
    }
  }]);

  return ReleasePriceCalculationConverterImpl;
}(ReleasePriceCalculationConverter_1.ReleasePriceCalculationConverter);

ReleasePriceCalculationConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ConstraintSettingsConverter_1.ConstraintSettingsConverter, OptimizationGoalsSettingsConverter_1.OptimizationGoalsSettingsConverter, StrategySettingsConverter_1.StrategySettingsConverter])], ReleasePriceCalculationConverterImpl);
exports.ReleasePriceCalculationConverterImpl = ReleasePriceCalculationConverterImpl;